// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__rpr-8","header":"PatientQuestionnaire_header__2AdYS","info":"PatientQuestionnaire_info__mOiZH"};